/**
 * Home Services section – Motion inView for floating card animation
 * Targets the floating card for slide-in on scroll
 */

import { inView, animate } from 'motion';

const init = () => {
  const section = document.querySelector('.wp-block-group.is-style-section-home-services');
  if (!section) return;

  const floatingCard = section.querySelector('.wp-block-group.is-style-floating-card');
  if (!floatingCard) return;

  inView(
    floatingCard,
    () => {
      animate(floatingCard, { x: 0, opacity: 1 }, { duration: 0.5, ease: 'easeOut' });
    },
    { once: true, amount: 0.2 }
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const floatingCard = document.querySelector(
    '.wp-block-group.is-style-section-home-services .wp-block-group.is-style-floating-card'
  );
  if (floatingCard) {
    floatingCard.style.opacity = '0';
    floatingCard.style.transform = 'translateX(20px)';
  }
  init();
});
